export const buttonSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};
